import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberFilters } from '@/lib/filterMemory';

/** Страница называет свои «константные» URL-параметры — сайдбар вернёт их при
 *  следующем переходе сюда (см. lib/filterMemory). Отсутствие ключа в URL тоже
 *  запоминается: «сегодня» у Статистики намеренно живёт без from/to. */
export function useRememberFilters(keys: readonly string[]): void {
  const { pathname, search } = useLocation();
  const joined = keys.join('|');
  useEffect(() => {
    rememberFilters(pathname, new URLSearchParams(search), joined.split('|'));
  }, [pathname, search, joined]);
}
